import { useEffect, useState } from "react";
import { getReturnRequests, updateReturnStatus } from "../api";

function ReturnRequests() {
  const [returns, setReturns] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    fetchReturns();
  }, []);

  const fetchReturns = async () => {
    try {
      const res = await getReturnRequests();

      if (res.data.success) {
        setReturns(res.data.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const changeStatus = async (status) => {
    try {
      await updateReturnStatus(selected._id, {
        status,
      });

      fetchReturns();
      setSelected(null);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-6">Return Requests</h1>

      <div className="bg-white rounded-xl shadow overflow-hidden">
        {/* Desktop Table */}
        <div className="hidden lg:block overflow-x-auto rounded-xl">
          <table className="w-full min-w-[800px]">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-4 text-left">Order</th>
                <th className="p-4 text-left">Customer</th>
                <th className="p-4 text-left">Reason</th>
                <th className="p-4 text-left">Status</th>
                <th className="p-4 text-center">Action</th>
              </tr>
            </thead>

            <tbody>
              {returns.map((item) => (
                <tr key={item._id} className="border-t hover:bg-gray-50">
                  <td className="p-4 whitespace-nowrap">{item.orderId}</td>

                  <td className="p-4 whitespace-nowrap">{item.user?.name}</td>

                  <td className="p-4">{item.reason}</td>

                  <td className="p-4">
                    <span className="px-3 py-1 rounded-full bg-yellow-100 text-yellow-700 text-sm">
                      {item.status}
                    </span>
                  </td>

                  <td className="p-4 text-center">
                    <button
                      onClick={() => setSelected(item)}
                      className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg"
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile Cards */}
        <div className="lg:hidden space-y-4">
          {returns.map((item) => (
            <div
              key={item._id}
              className="bg-white border rounded-xl shadow-sm p-4"
            >
              <div className="flex justify-between items-start">
                <div>
                  <p className="text-xs text-gray-500">Order ID</p>
                  <h3 className="font-semibold break-all">{item.orderId}</h3>
                </div>

                <span className="px-3 py-1 rounded-full bg-yellow-100 text-yellow-700 text-xs">
                  {item.status}
                </span>
              </div>

              <div className="mt-4">
                <p className="text-xs text-gray-500">Customer</p>
                <p className="font-medium">{item.user?.name}</p>
              </div>

              <div className="mt-3">
                <p className="text-xs text-gray-500">Reason</p>
                <p>{item.reason}</p>
              </div>

              <button
                onClick={() => setSelected(item)}
                className="w-full mt-5 bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-lg font-medium"
              >
                View Details
              </button>
            </div>
          ))}
        </div>

        {/* Empty State */}
        {returns.length === 0 && (
          <div className="text-center py-10 text-gray-500">
            No Return Requests Found
          </div>
        )}
      </div>
      {selected && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-white w-full max-w-2xl rounded-lg shadow-2xl overflow-hidden h-full max-h-[90vh] overflow-y-auto">
            {/* Header */}
            <div className="bg-gradient-to-r from-green-600 to-emerald-500 px-6 py-5 text-white">
              <div className="flex justify-between items-center">
                <div>
                  <h2 className="text-2xl font-bold">Return Request</h2>
                  <p className="text-green-100 text-sm mt-1">
                    Manage customer return request
                  </p>
                </div>

                <span
                  className={`px-4 py-2 rounded-full text-sm font-semibold
              ${
                selected.status === "Pending"
                  ? "bg-yellow-100 text-yellow-700"
                  : selected.status === "Approved"
                    ? "bg-green-100 text-green-700"
                    : selected.status === "Rejected"
                      ? "bg-red-100 text-red-700"
                      : selected.status === "Pickup Scheduled"
                        ? "bg-blue-100 text-blue-700"
                        : selected.status === "Received"
                          ? "bg-purple-100 text-purple-700"
                          : selected.status === "Refunded"
                            ? "bg-orange-100 text-orange-700"
                            : "bg-white text-green-700"
              }`}
                >
                  {selected.status}
                </span>
              </div>
            </div>

            {/* Body */}
            <div className="p-6 space-y-5">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                {/* Left Side */}
                <div className="space-y-4">
                  <div className="grid grid-cols-1  gap-4">
                    <div className="bg-gray-50 rounded-xl p-4 border flex justify-between items-center">
                      <p className="text-sm text-gray-500">Customer</p>

                      <h3 className="font-bold mt-1">{selected.user?.name}</h3>
                    </div>
                    <div className="bg-gray-50 rounded-xl p-4 border flex justify-between items-center">
                      <p className="text-sm text-gray-500">Order ID</p>

                      <h3 className="font-bold mt-1 break-all">
                        {selected.orderId}
                      </h3>
                    </div>
                  </div>

                  <div className="bg-gray-50 rounded-xl p-4 border flex justify-between items-center">
                    <p className="text-sm text-gray-500">Email</p>

                    <h3 className="font-semibold mt-1 break-all">
                      {selected.user?.email}
                    </h3>
                  </div>

                  <div className="bg-orange-50 rounded-xl p-4 border border-orange-200">
                    <p className="text-sm text-gray-500">Return Reason</p>

                    <h3 className="font-semibold text-orange-700 mt-1">
                      {selected.reason}
                    </h3>
                  </div>
                </div>

                {/* Right Side */}
                <div className="bg-blue-50 rounded-xl p-4 border border-blue-200 flex flex-col">
                  <p className="text-sm text-gray-500">Description</p>

                  <div className="mt-2 flex-1">
                    <p className="font-medium whitespace-pre-wrap break-words">
                      {selected.description || "No description available"}
                    </p>
                  </div>
                </div>
              </div>

              {/* Return Progress */}
           <div>
  <h4 className="font-semibold text-lg mb-6">
    Return Progress
  </h4>

  {(() => {
    const steps = [
      "Requested",
      "Approved",
      "Pickup",
      "Received",
      "Refunded",
      "Completed",
    ];

    const currentStep =
      selected.status === "Pending"
        ? 0
        : selected.status === "Approved"
        ? 1
        : selected.status === "Pickup Scheduled"
        ? 2
        : selected.status === "Received"
        ? 3
        : selected.status === "Refunded"
        ? 4
        : selected.status === "Completed"
        ? 5
        : 0;

    return (
      <div className="overflow-x-auto pb-2">
        <div className="flex items-start min-w-[630px] relative">

          {/* Line */}
          <div className="absolute top-5 left-8 right-8 h-1 bg-gray-200 rounded-full">
            <div
              className="h-full bg-green-600 rounded-full transition-all duration-500"
              style={{
                width: `${(currentStep / (steps.length - 1)) * 100}%`,
              }}
            />
          </div>

          {steps.map((step, index) => (
            <div
              key={step}
              className="flex flex-col items-center flex-1 relative z-10"
            >
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center font-bold transition
                ${
                  index <= currentStep
                    ? "bg-green-600 text-white shadow-lg"
                    : "bg-gray-200 text-gray-500"
                }`}
              >
                {index < currentStep ? "✓" : index + 1}
              </div>

              <p
                className={`mt-3 text-xs text-center w-20
                ${
                  index <= currentStep
                    ? "text-green-700 font-semibold"
                    : "text-gray-500"
                }`}
              >
                {step}
              </p>
            </div>
          ))}
        </div>
      </div>
    );
  })()}
</div>
              {/* Buttons */}

              {selected.status === "Pending" && (
                <div className="grid grid-cols-2 gap-4">
                  <button
                    onClick={() => changeStatus("Approved")}
                    className="bg-green-600 hover:bg-green-700 text-white py-3 rounded-xl font-semibold"
                  >
                    ✓ Approve
                  </button>

                  <button
                    onClick={() => changeStatus("Rejected")}
                    className="bg-red-600 hover:bg-red-700 text-white py-3 rounded-xl font-semibold"
                  >
                    ✕ Reject
                  </button>
                </div>
              )}

              {selected.status === "Approved" && (
                <button
                  onClick={() => changeStatus("Pickup Scheduled")}
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-xl font-semibold"
                >
                  Schedule Pickup
                </button>
              )}

              {selected.status === "Pickup Scheduled" && (
                <button
                  onClick={() => changeStatus("Received")}
                  className="w-full bg-purple-600 hover:bg-purple-700 text-white py-3 rounded-xl font-semibold"
                >
                  Product Received
                </button>
              )}

              {selected.status === "Received" && (
                <button
                  onClick={() => changeStatus("Refunded")}
                  className="w-full bg-orange-600 hover:bg-orange-700 text-white py-3 rounded-xl font-semibold"
                >
                  Refund Customer
                </button>
              )}

              {selected.status === "Refunded" && (
                <button
                  onClick={() => changeStatus("Completed")}
                  className="w-full bg-emerald-600 hover:bg-emerald-700 text-white py-3 rounded-xl font-semibold"
                >
                  Complete Return
                </button>
              )}

              {(selected.status === "Completed" ||
                selected.status === "Rejected") && (
                <div
                  className={`rounded-xl p-4 text-center font-semibold
              ${
                selected.status === "Completed"
                  ? "bg-green-100 text-green-700"
                  : "bg-red-100 text-red-700"
              }`}
                >
                  {selected.status === "Completed"
                    ? "✅ Return Process Completed"
                    : "❌ Return Request Rejected"}
                </div>
              )}

              <button
                onClick={() => setSelected(null)}
                className="w-full border-2 border-gray-300 hover:bg-gray-100 py-3 rounded-xl font-semibold"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ReturnRequests;
